function random(min, max) {
  return Math.floor(Math.random() * ((max - min) + 1)) + min;
}

/**
 * 生成随机密码
 * @return {[type]} 随机密码字符串
 */
export function randomPassword() {
  const source = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', "!\"#$%&'()*+,-./:;<=>?@[]^_`{|}~"];
  const pswLength = random(8, 10);
  let psw = '';

  for (let i = 0; i < pswLength; i += 1) {
    const item = source[random(0, 2)];
    psw += item.charAt(random(0, item.length - 1));
  }

  for (let j = 0; j < 4; j += 1) {
    const charac = source[j].charAt(random(0, source[j].length - 1));
    const randomSplit = random(0, source[j].length - 1);
    psw = [psw.slice(0, randomSplit), charac, psw.slice(randomSplit)].join('');
  }

  return psw;
}

export function getValueByPath(object, prop) {
  const paths = (prop || '').split('.');
  let current = object;
  let result = null;
  for (let i = 0, j = paths.length; i < j; i += 1) {
    const path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
}

export function compare(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }
  if (typeof a === 'boolean' && typeof b === 'boolean') {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
  if (typeof a === 'number' && typeof b === 'number') {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
  if (typeof a === 'number' && typeof b === 'string') {
    return -1;
  }
  if (typeof a === 'string' && typeof b === 'number') {
    return 1;
  }
  return 1;
}

export function compareIgnoreCase(a, b) {
  if ((!a && b) || (a && !b)) {
    return 1;
  }

  const ta = typeof a === 'string' ? a.toLowerCase() : a;
  const tb = typeof b === 'string' ? b.toLowerCase() : b;

  return compare(ta, tb);
}

export default {
  randomPassword() {
    return randomPassword();
  },
};



// WEBPACK FOOTER //
// ./src/utils/index.js